export const REVIEW_HAPPY_MOMENT_DEDUP_MS = 1500;
export const REVIEW_POPUP_FREE_DELAY_MS = 400;
export const REVIEW_THANK_YOU_AUTO_CLOSE_MS = 2500;

export const REVIEW_FLOW_STORAGE_KEY = 'reviewFlowState';
export const REVIEW_FLOW_TRIGGER_COUNTERS_STORAGE_KEY =
  'reviewFlowTriggerCounters';

export const REVIEW_CONFIG_COLLECTION = 'appConfig';
export const REVIEW_CONFIG_DOC_ID = 'reviewFlow';
export const REVIEW_STATE_COLLECTION = 'reviewFlowStatus';
export const REVIEW_FEEDBACK_SUBCOLLECTION = 'feedback';

export const TRUSTPILOT_FALLBACK_URL =
  process.env.NEXT_PUBLIC_TRUSTPILOT_REVIEW_URL || '';

export const TRUSTPILOT_POPUP_WIDTH = 560;
export const TRUSTPILOT_POPUP_HEIGHT = 760;

export const TRUSTPILOT_EVALUATE_URL =
  'https://www.trustpilot.com/evaluate/pdfgenius.com';
